module.exports = __webpack_public_path__ + "static/media/capsule.77e4cc32.svg";